// FT-205 REQ-01. Сайт справки выбирается по стране компании — по тому же правилу, по которому
// интерфейс показывает функции только России (CompanyProfile.vue: country == 'Russia' || 'Россия').
// docs.rentprog.ru описывает российские функции; всем остальным странам, включая Беларусь и
// Казахстан (решение USER, FT-205 DEC-04), — docs.rentprog.com, при русском интерфейсе — /ru.
// Компания не загружена — .com (FT-205 CON-01). Склейка с путём — docsUrl в utils/stageCard.
import { docsUrl } from "@/utils/stageCard";

const RU_SITE = "https://docs.rentprog.ru";
const WORLD_SITE = "https://docs.rentprog.com";
const RUSSIA = ["Russia", "Россия"];

export function docsBase(company, locale) {
  if (company && RUSSIA.includes(company.country)) return RU_SITE;
  return locale === "ru" ? `${WORLD_SITE}/ru` : WORLD_SITE;
}

// Ссылка приложения на страницу справки. Путь — адрес русского корпуса (`/dokumenty/shablony`), тот же,
// что в StageCard (docs_path) и RentToOwnSettingsCard: на .ru и .com/ru это сам адрес страницы, английская
// версия .com уводит его 301 на свою (rentalman_docs scripts/lib-redirects.mjs). Корень справки — "/".
// Старый helpcenter лендинга с 2026-10-28 отдаёт 301 только на главную docs, поэтому ссылки — сюда.
export function docsPageUrl(company, locale, path) {
  return docsUrl(docsBase(company, locale), path);
}
